import { useEffect, useState } from 'react';
import { arrayOf, oneOfType, shape, string } from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { i18n } from '@lingui/core';

import messageDescriptor from '../../lingui/LinguiPropTypes';
import { filterPropTypes, filterPropDefaults } from '../../page-framework/filter/FilterPropTypes';

function OptionFilter({ options, state, filterActions }) {
    const [option, setOption] = useState(state);

    useEffect(() => {
        setOption(state);
    }, [state]);

    function handleOptionChanged(event) {
        const newOption = event.target.value;
        setOption(newOption);
        filterActions.setState(newOption);
        filterActions.setValid(newOption !== undefined);
    }

    return (
        <RadioGroup name="option" value={option || null} onChange={handleOptionChanged}>
            {options.map((anOption) => {
                return (
                    <FormControlLabel
                        value={anOption.value}
                        key={anOption.value}
                        control={<Radio />}
                        label={i18n._(anOption.name)}
                    />
                );
            })}
        </RadioGroup>
    );
}

OptionFilter.propTypes = {
    filterActions: filterPropTypes.filterActions,
    state: string,
    options: arrayOf(
        shape({
            name: oneOfType([string, messageDescriptor]),
            value: string.isRequired,
        })
    ).isRequired,
};

OptionFilter.defaultProps = {
    ...filterPropDefaults,
    state: undefined,
};

export default OptionFilter;
